<script>
  import Base from './Base'

  export default {
    extends: Base,
    components: {Base},
    name: 'BaseDialog',
    computed: {

    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/BaseDialog.vue